<template>
  <commonTable
    :fields="currentRepairDeviceTableFields"
    :items="currentRepairDeviceTableItems"
    :otherTheme="'tbody-green'"
    stickyHeader="350px"
    class="mb-5"
  >
    <template #header>當前報修機台</template>
    <template #cell(item)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.index + 1 }}</div>
      </template>
      <template v-else>
        {{ data.index + 1 }}
      </template>
    </template>
    <template #cell(device)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(time)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(description)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(personnel)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">
          {{ data.value == "" ? "-" : data.value }}
        </div></template
      >
      <template v-else>
        {{ data.value == "" ? "-" : data.value }}
      </template>
    </template>
    <template #cell(startTime)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">
          {{ data.value == "1980-01-01 00:00:00" ? "-" : data.value }}
        </div></template
      >
      <template v-else>
        {{ data.value == "1980-01-01 00:00:00" ? "-" : data.value }}
      </template>
    </template>
    <template #cell(category)="data">
      <template v-if="data.value == 3">
        <div style="color: red">搶修</div></template
      >
      <template v-else>報修</template>
    </template>
  </commonTable>
  <commonTable
    :fields="maintenanceInstructionsTableFields"
    :items="maintenanceInstructionsTableItems"
    :rowClick="completeWorkRowClick"
    :otherTheme="'tbody-green'"
    stickyHeader="350px"
  >
    <template #header>待填維修說明</template>
    <template #cell(item)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.index + 1 }}</div></template
      >
      <template v-else>
        {{ data.index + 1 }}
      </template>
    </template>
    <template #cell(device)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(startTime)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(endTime)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(category)="data">
      <template v-if="data.value == 3">
        <div style="color: red">搶修</div></template
      >
      <template v-else>報修</template>
    </template>
    <template #cell(personnel)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
    <template #cell(totalTime)="data">
      <template v-if="data.item.category == 3">
        <div style="color: red">{{ data.value }}</div></template
      >
      <template v-else>
        {{ data.value }}
      </template>
    </template>
  </commonTable>
</template>

<script>
import commonTable from "@/components/commonTable.vue";
import { inject, ref } from "vue";
export default {
  components: {
    commonTable,
  },
  setup() {
    const fillInInstructions = inject("fillInInstructions");
    const commonMethods = inject("commonMethods");
    const currentRepairDeviceTableFields = inject(
      "currentRepairDeviceTableFields"
    );
    const currentRepairDeviceTableItems = inject(
      "currentRepairDeviceTableItems"
    );
    const maintenanceInstructionsTableFields = inject(
      "maintenanceInstructionsTableFields"
    );
    const maintenanceInstructionsTableItems = inject(
      "maintenanceInstructionsTableItems"
    );

    const completeWorkRowClick = commonMethods.completeWorkRowClick;

    return {
      fillInInstructions,
      currentRepairDeviceTableFields,
      currentRepairDeviceTableItems,
      maintenanceInstructionsTableFields,
      maintenanceInstructionsTableItems,
      completeWorkRowClick,
    };
  },
};
</script>

<style></style>
